module.exports = __webpack_public_path__ + "static/img/icon-1.27ac16b5.png";